import { render, staticRenderFns } from "./BLModifyNotiPop.vue?vue&type=template&id=9e40714e"
import script from "./BLModifyNotiPop.vue?vue&type=script&lang=js"
export * from "./BLModifyNotiPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e40714e')) {
      api.createRecord('9e40714e', component.options)
    } else {
      api.reload('9e40714e', component.options)
    }
    module.hot.accept("./BLModifyNotiPop.vue?vue&type=template&id=9e40714e", function () {
      api.rerender('9e40714e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLModifyNotiPop.vue"
export default component.exports